// src/components/AboutUs.js

import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import bg from './img5/hotel6.jpg'
import room from './img5/room.png'
import spa from './img5/spa3.jpg'
import dining from './img5/dining.jpg'
import wel from './img5/bg3.jpg'
import alka from './img5/alka1.jpg'
import brand from './img5/brand2.jpg'
import me from './img5/me.jpg'
import himanshu from './img5/himanshu.jpg'
import sagar from './img5/sagar2.jpg'
import nik from './img5/nikhil.jpg'
import './about.css'; // Import the CSS file for styling
import Footer from '../Footer';
import Header from '../Header';
import ScrollButtons from '../ScrollButtons';

const AboutUs = () => {
  return (
    <div>
      <Header/>
      <ScrollButtons/>
    <div className='cantainer-fluid'>
      <img src={bg} className=' bg img-fluid'/>
      <div className="text-overlay">
         <h3 style={{fontSize:'45px',paddingLeft:'45px'}} >About Us</h3>
        Welcome to Our Hotel</div>
        <div className='container'>
      <div  className='row'style={{margin:"20px"}}>
      <div className='col-sm-6'>
      <h1>Welcome!</h1>
            <p>
            Welcome to the Management System, where efficiency and exceptional guest service meet. Our system is designed to streamline all aspects of hotel operations, ensuring smooth and effortless management from check-in to check-out.Far far away,behind the world monuntains,far
              from the countries vkalia and consonatia,
              thier live the blinds texts separeted they live in 
              bookmarksgrove Rights at the coast of the semanitics
              a large langauge ocean
             
            </p>
      </div>
      <div className='col-sm-6 wel'>
        <img src={wel} style={{ width:"100%" ,height:"300px", borderRadius:"10px"}}/>
      </div>
      </div>
      </div>
      
      {/* Location and Facilities Section */}
      <div className='container'>
      <div className="mt-5 location" >
        <h2 className="text-center">Location & Facilities</h2>
        <div className="row text-center mt-4">
          <div className="col-md-4">
            <img src={room}/>
            <h4>Luxury Rooms</h4>
            <p style={{textAlign:"justify"}}>Luxury room ek aisi jaga hoti hai jahan har chhoti se chhoti cheez ko dhyan me rakhkar suvidhaon aur comfort ka vichar kiya jata hai. Yahan high-end furniture, advanced technology aur personalized services ka perfect blend hota hai, jo ek unforgettable experience banata hai.</p>
          </div>
          <div className="col-md-4">
            <img src={dining}/>
            <h4>Dining</h4>
            <p style={{textAlign:"justify"}}>A dining room offers a refined space for guests to enjoy gourmet meals in a sophisticated and comfortable setting. With elegant furnishings, ambient lighting, and impeccable service, it provides the perfect atmosphere for memorable dining experiences.</p>
          </div>
          <div className="col-md-4">
            <img src={spa}/>
            <h4>Spa & Wellness</h4>
            <p style={{textAlign:"justify"}}>Spa & Wellness ek aisa anubhav hai jisme relaxation, rejuvenation aur stress relief ke liye alag-alag therapies aur treatments diye jaate hain. Yeh aapki body aur mind dono ko tazgi aur sukoon deta hai, jisse aap apne daily stress se chutkaara paa sakte hain..</p>
          </div>
        </div>
      </div>
      </div>
      <div className='container'>
      <div className="about-us-team">
        <h2 style={{textAlign:"center"}}>Meet Our Team</h2>
        <p style={{textAlign:"justify"}}>
        Team wo hai jahan har insan apni apni khasiyat ke sath ek doosre ka sahara ban kar kaam karta hai. Har member apni mahnat se team ko aage barhata hai, aur mil kar mushkilein asaan ho jaati hain. Teamwork me na sirf jazba hota hai, balki har kisi ka apna role bhi mahatvapurn hota hai. Jab sab ekjut ho, toh har manzil mumkin lagti hai.         
        </p>
        <div className='row'>
        <div className='col-sm-12'>
        <div className="team-members">
          <div className="team-member">
            <img src={me} alt="Manager" />
            <h3>Gopal singh</h3>
          <h5>College .. SICS Chitrakoot</h5>
          <h6>BCA</h6>
          </div>
          <div className="team-member">
            <img src={brand} alt="Chef" />
            <h3>Arvind kumar(Brand)</h3>
            <h5>College.. GP Kulpahad</h5>
            <h6>Polytechnic</h6>
          </div>
          <div className="team-member">
            <img src={alka} alt="Receptionist" />
            <h3>Alka giri</h3>
            <h5>College.. GP Jaunpur</h5>
            <h6>Polytechnic</h6>
          </div>
          </div>
          </div>
          </div>
        <div className='row'>
        <div className='col-sm-12'>
        <div className="team-members">
          <div className="team-member">
            <img src={himanshu} alt="Manager" />
            <h3>Himanshu giri</h3>
            <h5>Colleage.. GP Jaunpur</h5>
            <h6>Polytechnic</h6>
          </div>
          <div className="team-member">
            <img src={sagar} alt="Chef" />
            <h3>Sagar Rathaur</h3>
            <h5> College.. GP mathogarth</h5>
            <h6>Polytechnic</h6>
          </div>
          <div className="team-member">
            <img src={nik}/>
            <h3>NIkhil Jaiswal</h3>
            <h5>College.. GP Kulpahad</h5>
            <h6>Polytechnic</h6>
          </div>
          </div>
          </div>
          </div>
         
      </div>
      </div>
    </div>
    <Footer/>
    </div>
  );
};

export default AboutUs;